import { PageInfo } from "@/framework";

export const defaultPageInfo: PageInfo = {
    page: 1,
    pageSize: 20,
    totalItems: 0,
    pageCount: 0,
};